<template>
  <div>
    <page-title
      heading="Pembayaran"
      :breadcrumb="[
        {
          label: 'Pembayaran',
          link: '/klinik-pembayaran'
        },
        {
          label: 'List Pembayaran',
          active: true
        }
      ]"
      class="layout-gantung ninja-shadow"
    />

    <div class="container-fluid __zoom_display_pembayaran">
      <div class="card card-box ninja-shadow">
        <div class="card-body">
          <b-row class="head-filter">
            <b-col md="2" class="pr-0">
              <label class="lb-header-filter" style="margin-bottom:15px;"
                >Hari, Tanggal</label
              >
              <date-picker
                v-model="from"
                type="date"
                range
                format="DD-MM-YYYY"
                value-type="YYYY-MM-DD"
                placeholder="DD-MM-YYYY"
                :style="'width: 100%'"
                @input="searchValueChanged($event, 'from')"
              >
              </date-picker>
            </b-col>
            <b-col class="pr-0">
              <label class="lb-header-filter">Poliklinik</label>
              <vue-select-clearable
                :options="optionPoli"
                v-model="poliklinik_id"
                :placeholder="'Semua Poliklinik'"
                @input="
                  searchValueChanged(
                    $event == null ? '' : $event.value,
                    'poliklinik_id'
                  )
                "
                class="custom-v-select-header-antrean mt-2"
                style="width:100%;background-color:#ffffff;"
              >
                <template slot="option" slot-scope="option">
                  {{ option.label }}
                </template>
                <template slot="selected-option" slot-scope="option">
                  {{ option.label }}
                </template>
              </vue-select-clearable>
            </b-col>
            <b-col class="pr-0">
              <label class="lb-header-filter">Dokter</label>
              <vue-select-clearable
                :options="optionDokter"
                v-model="dokter_id"
                :disabled="poliklinik_id == null"
                @input="
                  searchValueChanged(
                    $event == null ? '' : $event.value,
                    'dokter_id'
                  )
                "
                :placeholder="'Semua Dokter'"
                class="custom-v-select-header-filter mt-2"
                style="width:100%;background-color:#ffffff;"
              >
                <template slot="option" slot-scope="option">
                  {{ option.label }}
                </template>
                <template slot="selected-option" slot-scope="option">
                  {{ option.label }}
                </template>
              </vue-select-clearable>
            </b-col>
            <b-col class="pr-0">
              <label class="lb-header-filter">Kategori Pasien</label>
              <vue-select-clearable
                :options="optionKategoriPasien"
                v-model="kategori_id"
                :disabled="poliklinik_id == null"
                :placeholder="'Semua Kategori Pasien'"
                @input="
                  searchValueChanged(
                    $event == null ? '' : $event.value,
                    'kategori_id'
                  )
                "
                class="custom-v-select-header-filter mt-2"
                style="width:100%;background-color:#ffffff;"
              >
                <template slot="option" slot-scope="option">
                  {{ option.label }}
                </template>
                <template slot="selected-option" slot-scope="option">
                  {{ option.label }}
                </template>
              </vue-select-clearable>
            </b-col>
            <b-col class="pr-0">
              <label class="lb-header-filter">Metode Pembayaran</label>
              <vue-select-clearable
                :options="optionPembayaran"
                v-model="metode_pembayaran"
                :disabled="poliklinik_id == null"
                :placeholder="'Semua Metode'"
                @input="
                  searchValueChanged(
                    $event == null ? '' : $event,
                    'metode_pembayaran'
                  )
                "
                class="custom-v-select-header-filter mt-2"
                style="width:100%;background-color:#ffffff;"
              >
                <template slot="option" slot-scope="option">
                  {{ option }}
                </template>
                <template slot="selected-option" slot-scope="option">
                  {{ option }}
                </template>
              </vue-select-clearable>
            </b-col>
            <b-col></b-col>
          </b-row>
          <div class="stright-line"></div>
          <b-col md="12">
            <DataTableWrapper
              :perPage="perPage"
              :fromPage="fromPage"
              :toPage="toPage"
              :totalEntries="totalEntries"
              :currentPage="currentPage"
              :callbackFunc="fetchListPembayaran"
              @valueChanged="handleValueChanged"
            >
              <template v-slot:right-header>
                <b-button
                  v-if="hasFeatures('download')"
                  variant="primary"
                  class="align-self-end mr-3"
                  :disabled="selectedId.length == 0"
                  @click="downloadPembayaran"
                >
                  <font-awesome-icon icon="download" />
                  Download Data
                </b-button>
              </template>

              <div
                id="pembayaran-table"
                style="height: 500px; overflow-x: scroll;"
              >
                <b-table
                  :items="pembayaranList"
                  :fields="fieldList"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  thead-tr-class="izd-datatable"
                  :no-local-sorting="true"
                  class="sticky-header-pembayaran"
                >
                  <!-- HEADER SLOT -->
                  <template v-slot:head()="data">
                    {{ data.label }}
                    <b-input
                      size="sm"
                      class="mt-2 w-95"
                      v-if="data.field.searchable"
                      @input="searchValueChanged($event, data.field.key)"
                    />
                  </template>

                  <template v-slot:head(id)="{}">
                    <div class="bg-cst-box">
                      <b-form-checkbox
                        class="cst-cbox"
                        v-model="selectedAll"
                        @input="isSelectedAll = true"
                      ></b-form-checkbox>
                    </div>
                  </template>

                  <template v-slot:head(status)="data">
                    {{ data.label }}
                    <select
                      class="form-control select-status"
                      @input="
                        searchValueChanged($event.target.value, data.field.key)
                      "
                    >
                      <option value="">Semua</option>
                      <option value="BELUM LUNAS">Belum Lunas</option>
                      <option value="LUNAS">Lunas</option>
                    </select>
                  </template>

                  <template v-slot:head(action)="data">
                    <span class="mt-2">{{ data.label }}</span>
                  </template>

                  <!-- CELL SLOT -->
                  <template v-slot:cell(id)="data">
                    <b-form-checkbox
                      v-model="selectedId"
                      :value="data.item.id"
                      @input="isSelectedAll = false"
                    ></b-form-checkbox>
                  </template>

                  <template v-slot:cell(status)="data">
                    <span
                      :class="{ 'text-danger': !isPaidOff(data.item.status) }"
                    >
                      {{ data.item.status }}
                    </span>
                  </template>

                  <template v-slot:cell(metode_pembayaran)="data">
                    <span style="color: #4191ff;">{{
                      data.item.metode_pembayaran
                    }}</span>
                  </template>

                  <template v-slot:cell(total_net)="data">
                    <div style="display: flex; justify-content: space-between">
                      <span>{{ data.item.total_net }}</span>
                    </div>
                  </template>

                  <template v-slot:cell(action)="data">
                    <span
                      class="d-flex align-items-center justify-content-between"
                    >
                      <b-dropdown
                        id="dropdown-left"
                        variant="primary"
                        size="md"
                        :disabled="!isPaidOff(data.item.status)"
                      >
                        <template #button-content>
                          <font-awesome-icon icon="clone" />
                        </template>
                        <b-dropdown-item
                          @click="
                            isPaidOff(data.item.status)
                              ? showReceipt(data.item.id)
                              : () => {}
                          ">Lihat Struk</b-dropdown-item>
                        <b-dropdown-item
                          @click="showPembayaran(data.item.id)"
                        >Atur Komisi</b-dropdown-item>
                      </b-dropdown>
                      <b-button
                        v-tooltip="'Halaman Pembayaran'"
                        v-if="!isPaidOff(data.item.status)"
                        size="md"
                        variant="success"
                        style="margin-left: 10px"
                        @click="showPembayaran(data.item.id)"
                      >
                        <font-awesome-icon icon="money-bill" />
                      </b-button>
                    </span>
                  </template>
                  <template v-slot:cell(updated)="data">
                    <label style="font-size:13px;">
                      {{ formatLastModified(data.item.updated.at) }} <br />
                      by <b>{{ data.item.updated.by || "-" }}</b>
                    </label>
                  </template>
                </b-table>
              </div>
            </DataTableWrapper>
          </b-col>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { library } from "@fortawesome/fontawesome-svg-core";
import { union } from "lodash";
import startCase from "lodash/startCase";
import debounce from "lodash/debounce";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import moment from "moment";
import accounting from "accounting"
moment.locale("id");

import {
  faCopy,
  faDownload,
  faUpload,
  faSearch,
  faMoneyBill,
  faClone
} from "@fortawesome/free-solid-svg-icons";
library.add(faCopy, faUpload, faDownload, faSearch, faMoneyBill, faClone);

export default {
  components: {
    DataTableWrapper: () => import("../../components/DataTableWrapper"),
    "vue-select-clearable": () => import("@/components/VueSelectClearable.vue"),
    DatePicker
  },
  data() {
    return {
      firstLoadPembayaran: true,
      optionPoli: [],
      optionDokter: [],
      optionKategoriPasien: [],
      optionPembayaran: ["Tunai", "Transfer", "QRIS"],

      selectedKategori: null,
      selectedPoli: null,

      kategori_id: null,
      poliklinik_id: null,
      dokter_id: null,
      metode_pembayaran: null,
      from: [moment(new Date()).format("YYYY-MM-DD"), moment(new Date()).format("YYYY-MM-DD")],
      to: null,
      status_id: "",

      perPage: 10,
      currentPage: 1,
      rows: 0,
      fromPage: 0,
      toPage: 0,
      totalEntries: 0,
      sortBy: "",
      sortDesc: false,
      searchValue: [],

      fieldList: [
        {
          key: "id",
          label: "id",
          thStyle: "width: 50px",
          searchable: true,
          sortable: false
        },
        {
          key: "hari",
          label: "hari, tanggal",
          thStyle: "width: 160px",
          searchable: true,
          sortable: true
        },
        {
          key: "no_invoice",
          label: "no.invoice",
          thStyle: "width:125px",
          searchable: true,
          sortable: true
        },
        {
          key: "pasien",
          label: "nama pasien",
          thStyle: "width: 180px",
          searchable: true,
          sortable: true
        },
        {
          key: "poliklinik",
          label: "poliklinik",
          thStyle: "width: 120px",
          tdClass: "text-uppercase",
          searchable: true,
          sortable: true
        },
        {
          key: "dokter",
          label: "dokter",
          thStyle: "width: 180px",
          searchable: true,
          sortable: true
        },
        {
          key: "kategori",
          label: "kategori",
          thStyle: "width: 100px",
          tdClass: "text-uppercase",
          searchable: true,
          sortable: true
        },
        {
          key: "status",
          label: "status",
          thStyle: "width: 120px",
          tdClass: "text-uppercase txt-bold",
          searchable: true,
          sortable: true
        },
        {
          key: "metode_pembayaran",
          label: "metode",
          thStyle: "width: 100px;",
          tdClass: "text-uppercase txt-bold",
          searchable: true,
          sortable: true
        },
        {
          key: "total_net",
          label: "total",
          thStyle: "width: 150px",
          searchable: true,
          sortable: true
        },
        {
          key: "action",
          label: "actions",
          thStyle: "width: 90px",
          searchable: true,
          sortable: false
        },
        {
          key: "updated",
          label: "last modified",
          thStyle: "width: 150px",
          searchable: false,
          sortable: false
        }
      ],

      pembayaranList: [],

      selectedAll: false,
      isSelectedAll: false,
      currentPageChange: false,
      selectedId: []
    };
  },
  computed: {
    ...mapGetters(["getKlinikId", "getRolesName"])
  },
  created() {
    this.getPoli();
    this.getKategori();
  },

  watch: {
    selectedAll(val) {
      const { currentPage, perPage, selectedId, pembayaranList } = this;

      let selectedByUser = [...pembayaranList].splice(0, perPage).map(bhp => {
        return bhp.id;
      });

      if (!val && !this.currentPageChange && this.isSelectedAll) {
        this.selectedId = this.selectedId.filter(
          item => selectedByUser.indexOf(item) < 0
        );
      }

      if (val && this.isSelectedAll) {
        let mergeArray = selectedId.concat(selectedByUser);
        this.selectedId =
          this.selectedId.length > 0
            ? union(mergeArray, selectedId)
            : mergeArray;
      }
      this.isSelectedAll = false;
      this.currentPageChange = false;
    },
    currentPage(val) {
      this.selectedAll = false;
      this.currentPageChange = true;
      this.fetchListPembayaran().then(() => {
        this.activePageSelectedAll();
      });
    },
    perPage() {
      this.fetchListPembayaran();
    },
    selectedId() {
      this.activePageSelectedAll();
    },
    sortBy() {
      this.fetchListPembayaran();
    },
    sortDesc() {
      this.fetchListPembayaran();
    },
    poliklinik_id(val) {
      this.getDokter();
    },
    searchValue: {
      handler: function(val) {
        if (!this.firstLoadPembayaran) this.fetchListPembayaran();
      },
      deep: true
    }
  },
  methods: {
    getTodayDate() {
      return [moment(new Date()).format("YYYY-MM-DD"), moment(new Date()).format("YYYY-MM-DD")];
    },
    showReceipt(id) {
      this.$router.push({
        name: "klinik-pembayaran-struk",
        params: {
          pembayaran_id: id
        }
      });
    },
    showPembayaran(id) {
      this.$router.push({
        name: "klinik-pembayaran-tambah",
        params: {
          bayar_id: id
        }
      });
    },
    isPaidOff(status) {
      return status.toLowerCase() == "lunas";
    },
    formatLastModified(date) {
      return moment(date).format("MMM DD, YYYY @ HH:mm");
    },
    disabledDate(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      return (
        date < today ||
        date >
          new Date(today.getFullYear(), today.getMonth() + 2, today.getDate())
      );
    },
    activePageSelectedAll() {
      let activeBhp = this.pembayaranList.map(item => item.id);
      let allBhpSelected = this.selectedId.filter(
        item => activeBhp.indexOf(item) >= 0
      );

      if (activeBhp.length == allBhpSelected.length) this.selectedAll = true;
      else this.selectedAll = false;
    },
    hasFeatures(value) {
      const features = {
        download: ["pic_cabang", "frontdesk", "kasir"]
      };

      const isOwner = features[value].filter(feature => {
        return this.getRolesName.includes(feature);
      });
      return isOwner.length > 0 ? true : false;
    },
    async getPoli() {
      try {
        const res = await this.$axios.get(
          `layanan/poli?klinik_id=${this.getKlinikId}`
        );
        const { data, status } = res.data;
        if (status) {
          this.optionPoli = data.map(res => ({
            ...res,
            label: res.nama,
            value: res.id
          }));

          this.optionReschedulePoli = this.optionPoli;
        }
      } catch (error) {}
    },
    async getDokter() {
      try {
        const res = await this.$axios.get(
          `transaksi/list-dokter?klinik_id=${this.getKlinikId}&limit=50&poli_id=${this.poliklinik_id.value}`
        );
        const { data, status } = res.data;

        if (status) {
          this.optionDokter = data.reduce((result, item) => {
            if (item.data.title !== "LAINNYA") {
              let opt = {
                label: item.data.title,
                value: item.data.value
              };
              result.push(opt);
            }
            return result;
          }, []);
        }
      } catch (error) {}
    },
    async getKategori() {
      try {
        const res = await this.$axios.get(`kategori-pasien?klinik_id=${this.getKlinikId}`);
        const { data, status } = res.data;
        if (status) {
          this.optionKategoriPasien = data.map(res => ({
            ...res,
            label: res.nama,
            value: res.id
          }));
        }
      } catch (error) {}
    },
    async fetchListPembayaran() {
      if (this.firstLoadPembayaran) {
        this.searchValue = [
          {
            key: "from",
            value: this.from
          }
        ];
      }
      let response = await this.$axios.get(
        `klinik/pembayaran?klinik_id=${
          this.getKlinikId
        }&limit=${this.perPage}&page=${
          this.currentPage
        }${this.determineParameter()}`
      );
      this.firstLoadPembayaran = false;
      const { status, data } = response.data;

      if (status) {
        const {
          data: pembayaranList,
          total: totalEntries,
          to: toPage,
          from: fromPage
        } = data; //data.data

        this.pembayaranList = pembayaranList;
        this.rows = totalEntries || 0;
        this.toPage = toPage || 0;
        this.fromPage = fromPage || 0;
        this.totalEntries = totalEntries;

        return this;
      }
    },
    showDetailBhp() {},
    deleteBhp({ id, nama }) {
      this.$swal({
        text: `Apakah anda yakin akan menghapus data obat ${nama} ?`,
        type: "question",
        showCancelButton: true,
        cancelButtonText: startCase("tidak"),
        confirmButtonText: startCase("ya")
      }).then(res => {
        const { value } = res;
        if (value) {
          try {
            const res = this.$axios
              .delete(
                `klinik/bhp/${id}?klinik_id=${this.getKlinikId}`
              )
              .then(res => {
                const { status, data, message } = res.data;
                if (status) {
                  this.fetchListPembayaran();
                  this.$swal({
                    type: "success",
                    title: startCase("sukses hapus bhp"),
                    text: `Data BHP berhasil dihapus.`
                  });
                } else {
                  this.$swal({
                    text: message,
                    type: "warning"
                  });
                }
              });
          } catch (err) {}
        }
      });
    },
    // SETTING TABLE
    handleValueChanged({ perPage, currentPage }) {
      perPage && (perPage |> (_ => (this.perPage = _)));
      currentPage && (currentPage |> (_ => (this.currentPage = _)));
    },
    searchValueChanged: debounce(function(val, key) {
      if(key == "from" && val[0] == null && val[1] == null) {
        val = this.from =  this.getTodayDate()
      }

      if(key == "poliklinik_id" && val == '' ) {
        this.kategori_id= null
        this.poliklinik_id= null
        this.dokter_id= null
        this.metode_pembayaran= null
     
        this.searchValue.map(item => { 
          if(item.key == 'from')
            item.value = this.from = this.getTodayDate()
          else
            item.value = null 
        })
      }
      const { searchValue } = this;

      const z = searchValue.filter(item => item.key !== key);

      this.searchValue = [
        ...z,
        {
          key,
          value: val
        }
      ];

    }, 500),
    determineParameter() {
      const { searchValue, sortBy, sortDesc } = this;
      let v = "";

      searchValue.map(item => {
        const x = item.key;
        if (item.key == "from"){
          v += `&from=${item.value[0] || ""}`;
          v += `&to=${item.value[1] || ""}`;
        } else {
          v += `&${x}=${item.value || ""}`;
        }
      });

      if (sortBy) {
        v += `&column=${sortBy}&order=${sortDesc ? "desc" : "asc"}`;
      }

      return v;
    },
    async downloadPembayaran() {
      let arrId = {
        id: this.selectedId
      };

      const res = await this.$axios.post(
        `klinik/pembayaran/download`,
        arrId
      );
      const { status, data } = res.data;

      if (status) {
        let link = document.createElement("a");
        link.href = data.link;
        link.setAttribute("download", data.name);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.selectedId = [];
      } else {
        this.$swal({
          text: "Something went wrong",
          type: "error"
        });
      }
    },
    goUpload() {
      this.$store.commit("SET_UPLOAD_PASIEN", null);
      this.$router.push({
        name: "klinik-bhp-upload"
      });
    }
  },
  filters: {
    currency: function(value) {
      return accounting.formatColumn([value], "", 0, ".")[0]
    }
  }
};
</script>

<style lang="css">
.select-status {
  margin-top: 7px;
  height: 30px;
  font-size: 11pt;
  padding: 0;
}
.select-status option {
  font-size: 9pt;
}
.btn-primary-disable,
.btn-primary-disable:hover {
  background-color: #878ee3;
  border-color: #878ee3;
}

.txt-bold {
  font-weight: 600;
}

.lb-header-filter {
  color: #217fc3;
  font-weight: 600;
}

.mx-datepicker .mx-input {
  height: 41.7px !important;
}

.bg-cst-box {
  background: #fff;
  border: 1px solid #cdcdcd;
  width: 30px;
  margin: 15px auto;
  height: 30px;
  border-radius: 8px;
}

.cst-cbox .custom-control-input:checked ~ .custom-control-label::after {
  background-image: none !important;
}

.cst-cbox .custom-control-input:checked ~ .custom-control-label::before,
.cst-cbox .custom-control-input:checked ~ .custom-control-label::after {
  color: #fff;
  border-color: #cdcdcd;
  background-color: #6b6b72;
}

.cst-cbox .custom-control-label::before,
.cst-cbox .custom-control-label::after {
  border-radius: 4px;
  margin-top: 2px;
  margin-left: 3.2px;
}

.layout-gantung {
  border-radius: 0px 0px 10px 10px;
  max-height: 250px;
}

.ninja-shadow {
  box-shadow: 0px 8px 15px 0px lightgrey;
}

.head-filter {
  margin: 20px 0;
}

.stright-line {
  background-color: #dcecec;
  height: 2px;
  margin: 20px 0;
}

/* width */
#pembayaran-table::-webkit-scrollbar {
  width: 5px;
}

/* Track */
#pembayaran-table::-webkit-scrollbar-track {
  box-shadow: inset 0 0 1px grey;
  border-radius: 10px;
}

/* Handle */
#pembayaran-table::-webkit-scrollbar-thumb {
  background: #cdcdcd;
  border-radius: 10px;
}

/* Handle on hover */
#pembayaran-table::-webkit-scrollbar-thumb:hover {
  background: #cdcdcd;
}

@media screen and (max-width: 1380px) {
  .sticky-header-pembayaran {
    width: 135%;
  }
}

.sticky-header-pembayaran {
  width: 120%;
}

.sticky-header-pembayaran th {
  position: -webkit-sticky;
  position: sticky;
  top: -2px;
  z-index: 1;
}

.tooltip {
  display: block !important;
  z-index: 10000;
}

.table.b-table > thead > tr > [aria-sort]:not(.b-table-sort-icon-left) {
    padding-left: 8px;
    padding-right: 8px;
}

.__zoom_display_pembayaran {
  transform: scale(0.78);
  width: 132%;
  margin-left: -16%;
  margin-top: -150px !important;
}
</style>
